import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchCatalog = () => api.get("/catalog").then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const postCheckout = (payload) => api.post("/checkout", payload).then((r) => r.data);
export const postNewsletter = (payload) => api.post("/newsletter", payload).then((r) => r.data);
export const fetchReviews = (productSlug) =>
  api.get("/reviews", { params: productSlug ? { product_slug: productSlug } : {} }).then((r) => r.data);
export const postReview = (payload) => api.post("/reviews", payload).then((r) => r.data);
export const postQuiz = (payload) => api.post("/quiz", payload).then((r) => r.data);
export const fetchHerbs = () => api.get("/herbs").then((r) => r.data);
export const fetchGramTeas = () => api.get("/gram-teas").then((r) => r.data);
export const fetchQuizStats = (adminKey) =>
  api.get("/quiz/stats", { headers: { "X-Admin-Key": adminKey } }).then((r) => r.data);

export const money = (n, currency = "USD") =>
  n == null
    ? ""
    : new Intl.NumberFormat("en-US", { style: "currency", currency }).format(n);

// Route heavy product images through the backend resizer (mobile-first performance).
export const img = (url, w = 800) =>
  url ? `${API}/img?u=${encodeURIComponent(url)}&w=${w}` : url;
